import React, { useContext, useEffect } from "react";
import "./Cart.css";
import Item from "../Item/Item";
import {
  FinancialData,
  ItemDetailsData,
  RecommendedItem,
} from "../../../../Utils/DefinitionsInterfaces";
import { NFOLogoNoText } from "../../../../Assets/svgs";
import Subtotal from "../Subtotal/Subtotal";
import { motion } from "framer-motion";
import { yearEndSale } from "../../../../Assets/svgs";
import { UserContext } from "../../CheckoutPage";

interface CartProps {
  stateDefaultItems: FinancialData[];
  stateCheckoutItems: ItemDetailsData[];
  stateRecommendedItems: RecommendedItem[];
  cbRemoveProduct: (itemId: number) => void;
  cbAddRecommended: (itemId: number) => void;
  cbHandlePaymentClick: () => void;
}

const Cart = (props: CartProps) => {
  const userContext = useContext(UserContext);
  const individualReg = userContext?.individualReg ?? false;

  return (
    <div className="cart">
      <div className="cart-child">
        <div className="cart-title">
          <div>
            <div className="text-wrapper-2">Purchase Details</div>
          </div>
          <img
            src={NFOLogoNoText}
            className="nfo-logo-details-section"
            alt="NFO Logo"
          />
        </div>
        {props.stateDefaultItems.map((e, i) => {
          return (
            <Item
              //@ts-ignore
              stateCheckoutItem={props.stateDefaultItems[i]}
              cbRemoveProduct={props.cbRemoveProduct}
              key={`${e}` + i}
              isDefaultItem={true}
            />
          );
        })}
      </div>
      <div className="button-container">
        <Subtotal
          stateCheckoutItems={props.stateCheckoutItems}
          stateDefaultItems={props.stateDefaultItems}
          cbHandlePaymentClick={props.cbHandlePaymentClick}
        />
      </div>
    </div>
  );
};

export default Cart;
